module.exports = __webpack_public_path__ + "img/mesa_el_j.585d728a.png";